var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-center"},[_vm._v("You have reached this page by accident, please check the url.")])
}
var staticRenderFns = []

export { render, staticRenderFns }